module.exports = __webpack_public_path__ + "media/Ill Magnetic.83dd4559.mp3";